export const REACT_SLICK_SETTING = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    initialSlide: 0,
    slidesPerRow: 1,
    rtl: false,
    // nextArrow: <button type="button" className="slick-arrow slick-next"><img src="./../assets/images/arrow-right.png" alt="Next"/></button>,
    // prevArrow: <button type="button" className="slick-arrow slick-prev"><img src="./../assets/images/arrow-left.png" alt="Previous"/></button>,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 1
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1
            }
        }
    ]
};

export const WATCHLIST_SLICK_SETTING = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    currentSlide: 0,
    swipeToSlide: true,
    // nextArrow: <button type="button" className="slick-arrow slick-next"><img src="./../../assets/images/icon/arrow_right.png" alt="Next"/></button>,
    // prevArrow: <button type="button" className="slick-arrow slick-prev"><img src="./../../assets/images/icon/arrow_left.png" alt="Previous"/></button>,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

export const COMPLAIN_STATUS = {
    new: {
        icon: 'fas fa-meh-blank',
        text: 'تایید نشده',
        color: 'var(--red)',
    },
    verified: {
        icon: 'fas fa-angry',
        text: 'تایید شده',
        color: 'var(--blue)',
    },
    viewed: {
        icon: 'fas fa-meh-blank',
        text: 'مشاهده شده',
        color: 'var(--darkBlue)',
    },
    inProgress: {
        icon: 'fas fa-meh',
        text: 'در حال بررسی',
        color: 'var(--lightBlue)',
    },
    userWait: {
        icon: 'fas fa-grin-beam-sweat',
        text: 'در انتظار پاسخ کاربر',
        color: 'var(--green)',
    },
    brandWait: {
        icon: 'fas fa-frown',
        text: 'در انتظار پاسخ برند',
        color: 'var(--orange)',
    },
    satisfied: {
        icon: 'fas fa-smile',
        text: 'رضایت',
        color: 'var(--gold)',
    },
    unsatisfied: {
        icon: 'fas fa-angry',
        text: 'عدم رضایت',
        color: 'var(--red)',
    },
};

export const testimony = [
    {
        name: "علیرضا صادقیان",
        content: `من قبال در سفری که به یک کشور اروپایی رفتم محصولی خریدم و متوجه شدم ایراد دارد. یکی از دوستان اهالی همان کشور در سایتی
        مطلبی را ثبت کرد و بعد به من اطالع داد که می توانم به همان فروشگاه مراجعه کنم و محصول را تعویض نمایم. االن که در سایت
        فرابازار شکایت خودم را ثبت نمودم و مشکل من حل شد، فهمیدم که آن سایت خارجی هم مشابه فرابازار بوده است. در دنیا برای
        حمایت از حقوق مصرف کنندگان این روش‌ها خیلی استفاده می کنند و من خوشحالم که در ایران هم مشابه این سایت‌ها شکل گرفته
        است. امیدوارم که همه از این راهکار استفاده کنند تا شاهد مسئولیت پذیری بیشتر شرکتها باشیم.`
    },
    {
        name: "عباس حق پرست",
        content: `اینجانب بابت یخچال G26 سامسونگ شکایتی را مطرح کردم بودم و بعد از گذشت 2 روز و پیگیری فرابازار در مورد شکایت بنده، سام
        سرویس کل مبلغ را عودت داد و میخواهم از فرابازار تشکر کنم. عالی بود، واقعا چقدر خوب پیگیری کردید و من یک تجربه عالی
        داشتم.`
    },
    {
        name: "زهرا تاران",
        content: `بنده در مرداد ماه سال جاری خرید کاالیی انجام دادم که متاسفانه به دلیل تاخیر در ارسال کاال و عدم انجام تعهدات توسط شرکت و فروشگاه؛ بنده
        بارها به قسمت بازرسی کاال شکایت کردم ولی هیچ گونه رسیدگی انجام نشد. به ناچار از طریق اداره بازرسی اصناف شکایت مبنی بر تبلیغ کاالبرخالف
        واقع و امتناع از عرضه به موقع کاال انجام دادم که پروسه زمانبری بود و تاکنون به نتیجه نرسیدم تا اینکه از طریق اینستاگرام با پلتفرم فرابازار آشنا شدم
        و از طریق این پلتفرم شکایتم را مطرح کردم که خوشبختانه با پیگیری مصرانه و جدی کارشناسان فرابازار در عرض چند روز مشکل بنده حل شد.
        خواستم از این طریق هم از کارشناسان متعهد فرابازار تشکر کنم و هم پلتفرم فرابازار Farabazaar رو به سایر دوستانی که مشکلی مثل مشکل بنده
        براشون پیش اومده رو معرفی کنم تا مشکلشون از این طریق خیلی سریعتر حل بشه.`
    },
    {
        name: "سمیه حسینی تبار",
        content: `من یک تلویزیون 55 با وام در تیرماه از شرکت ... خریداری کرده بودم. بعد از پرداخت دو قسط االن تا شهریور ماه خبری از تلویزیون
        نبود و پیگیری ها و شکایت های من هیچ نتیجه ای نداد که در نهایت از طریق جستجو در گوگل با سایت فرابازار آشنا شدم و شکایت
        خودم را در سایت شما ثبت کردم.تشکر از پیگیری مجموعه زحمت کشتان، باالخره امروز عصر تلویزیون تحویل شد.`
    },
    {
        name: "فاطمه بغدادی",
        content: `وقتی داشتم در فرابازار ثبت شکایت می کردم باورم نمیشد که مشکل یخچال نو که در هنگام نصب متوجه خرابی اون شده بودیم حل بشه. چونکه یک
        اختالف پیچیده بین شرکت تولید کننده، فروشنده، راننده وانت و تکنسین نصب و ما برای پیدا کردن مسئول این مشکل بوجود آمد بود و کسی هم
        قبول دار نبود. در نهایت یک یخچال نو و خراب روی دست ما مونده بود و پیگیری از شرکت هم نتیجه ای نداشت. بعد از ثبت شکایت در فرابازار،
        یخچال جدید رو آوردن.
        بابت پیگیری هایی که انجام دادین و زحماتتون بی نهایت تشکر می کنم.`
    },
    {
        name: "محسن برجی",
        content: `تا به حال این چنین تجربه کاربری رو در ایران ندیده بودم. بعد از نوشتن شکایت خودم در فرابازار از سفر با قطار های VIP فدک در یک مسیر رفت و
        برگشت و تفاوت فاحش سطح کیفیت، از طرف فرابازار پیامی دریافت کردم که پیگیر موضوع خواهند بود و به شرکت فدک شکایت من را منتقل کردند.
        خیلی جالب بود که از شرکت فدک با من تماس گرفته شد و شکایت من را حل کردند. از سرویس منحصر به فرد و تجربه خاصی که در فرابازار داشتم،
        سپاسگزارم.`
    },
    {
        name: "مهدی روحانی",
        content: `پس از ثبت شکایت خودم در اتحادیه و پیگیری های فراوان متوجه این نکته شدم که سازکار شکایت در اتحادیه دچار تعارض منافع هست و در
        نهایت هم حل نشد. به این دلیل ساده که در برخی و شاید خیلی از مواقع کارشناسان اتحادیه به ضرر اعضای صنف خودشان نظر و رای نخواهند
        داد. همچینین قانون اصناف و نظارت اتحادیه از بازدارندگی کافی برخوردار نیست. ممکن است که در تخلفات مشهود اتحادیه به نفع مصرف
        کننده رای بدهد ولی قدرت اجرای آن در اتحادیه وجود ندارد. در تخلفات گرانفروشی که معموال به یک تذکر ساده ختم می شود. به نظرم رسید
        که باید شکایت خودم را در جایی مستقل ثبت کنم و با پلتفرم فرابازار آشنا شدم. امیدورام این روش بین همه مصرف کنندگان فراگیر بشه و به
        نظرم تنها راهکاری است باعث حفظ و رعایت حقوق مصرف کننده در بین فروشگاه‌ها و کسب و کارها میشه.`
    },
    {
        name: "زهرا زارعی",
        content: `تصور بهبود وضع کیفیت محصوالت و کاالها بدون داشتن یک راهکارهایی شبیه فرابازار که امکان کنشگری را به شهروندان و مصرف
        کنندگان می دهد، غیر ممکن است. جنبش های حقوق مصرف کننده و فضای پاسخگویی و مسئولیت پذیری شرکتها و برندها در دنیا
        باعث رشد و پیشرفت اقتصاد و افزایش سطح کیفیت محصوالت خارجی شده است. برای فرابازار آرزوی موفقیت دارم و استفاده از این
        سایت را به همه پیشنهاد می کنم.`
    },
    {
        name: "فاطمه روشن",
        content: `من این روزها که بعضا مجبور میشم خرید اینترنتی انجام بدم، در مواردی به مشکل برمی خورم هم سایت های معتبر هم فروشگاه های
        اینستاگرامی. از طریق تعزیرات پیگیر یک شکایت بودم و جوابی نگرفتم. در پاسخ گفتند که پنج هزار شکایت باز از این فروشگاه
        اینترنتی در تعزیرات وجود دارد و امکان حل شکایت وجود ندارد و اگر مسئله بسیار جدی است از طریق شکایت در قوه قضاییه موضوع
        را پیگیری کنید. وقتی حجم شکایات اینقدر زیاد است و دستگاه های اجرایی امکان پیگیری ندارد باید به دنبال راهکار خالقانه و
        جدیدی بود و از نظر من فرابازار این راهکار متفاوت و پاسخی هوشمند به این چالش اقتصادی و بروکراسی کشور است.`
    },
    {
        name: "محسن وفایی",
        content: `بعد از خرید لنز و عدسی عینک متوجه تقلبی بودن آن شدم و به اتحادیه عینک سازان مراجعه و از آن فروشگاه شکایت کردم. اتحادیه
        پس از چند بار احضار )که نزدیک به یک سال طول کشید( نهایتا توانست مدیر فروشگاه را به اتحادیه فرابخواند. در نهایت تصمیم گرفتم
        شکایت خودم را در سایت فرابازار ثبت کنم. دست مریزاد به طراحان این سایت جذاب.`
    },
    {
        name: "مریم یوسف صفت",
        content: `بعد از شکایت از یک فروشگاه اینترنتی پوشاک از طریق اتحادیه صنفی و اتحادیه کشوری کسب و کار مجازی جواب پیگیری اینجانب به شرح
        زیر میباشد :شاکی محترم )طبق بررسیهای انجام شده واحد صنفی به نشانی درج شده هیچگونه فعالیت پوشاکی ندارد و آموزشگاه موسیقی می
        باشد بنابراین رسیدگی به شکایت شما امکانپذیر نیست(. دیگه پول از دست رفتم برام مهم نبود و فقط به دنبال راهکاری بودم که از حق خودم
        دفاع کنم و نگذارم که به راحتی سرمن و دیگران کاله گذاشته بشه. بعد از جستجو در اینترنت با فرابازار آشنا شدم و شکایتم را ثبت کردم. بعد
        از مدتی که شکایت من در گوگل رتبه گرفت و در نتایج جستجو نمایش داده شد هم دیگران متوجه تخلفات گسترده اون فروشگاه اینترنتی
        شدند و هم مجبور شد که پول من را پس بده. در اخر هم از مجموعه محترم تشکر میکنم که این سایت رو برای چنین مشکالتی بوجود اوردین
        که صدای ما به جایی برسه و حقمون پایمال نشه. با سپاس از شما و مجموعه محترم و پیگیر`
    },
    {
        name: "محمد بابازاده",
        content: `یک تلویزیون از شرکت ... برای جهیزیه خواهرم از سایت بازنشستگی خریدم و پول را کامل پرداخت کردم و قرار بود بعد از دو ماه تحویل داده شود. شرکت
        تلویزیون را تحویل نداند و گفتند که قرارداد ما با سازمان بازنشستگی تمام شده. بعد از 5 ماه تحویل نداند و عروسی خواهرم برگزار شد و اگر مادرم متوجه این
        موضوع می شد حتما سکته می کرد. از شدت استرس و فشار روحی 2 بار بستری شدم ولی هیچکس موضوع را نمی دانست و من به خاطر حل این مشکل مجبور
        شدم تلویزیون خانه خودم را باز کرده و برای جهیزیه خواهرم ببرم. بعد از ثبت شکایت از طریق همه مراجع رسمی و دولتی و در فضای مجازی باز هم نتیجه ای
        نگرفتم. دوستی فرابازار را به من معرفی کرد و دست آخر اینجا شکایت کردم و بعد از چند روز به من اطالع دادند که موضوع در حال پیگیری است و بعد هم گفتند
        که حل شد و تلویزیون تا دو روز آینده به دست شما می رسد. البته من در ابتدا باورم نکردم تا اینکه تلویزیون به دستم رسید. االن کارتن تلویزیون جلوی من
        هست و هنوز باور نمی کنم. واقعا از شما ممنوم.`
    },
    {
        name: "حسام قاسمی پور",
        content: `چند ماه از خرید موتور سیکلت گذشته بود و بابت طوالنی شدن ارسال کارت موتور و کارت سوخت و موجود نبودن موتور سیکلت،
        تحویل اون به تعویق افتاده بود.
        تشکر از پیگیری و جدیت واقعی تان که منشی شرکت برای نقص مدارک تماس گرفتن و مشکل من حل شد.ای کاش دولت و مجلس از
        سایت فرابازار حمایت غیرمستقیم می کردند تا شما بتونید این رویه را با قدرت و قوی ادامه بدین و مشکل خیلی از شهروندان و مصرف
        کنندگان حل بشه.`
    },
    {
        name: "یوسف جلالی",
        content: `اینجانب یک یخچال فریزر خریداری نموده بودم که نمایندگی، تحویل کاال را در عرض ده روز تا دوهفته تعهد نموده بود ولی در فاکتوری
        که 5 ساعت پس از خرید، تحویل گردید، زمان تحویل را اردیبهشت 1401 درج نموده بودند. نمایندگی و بخش رسیدگی به شکایت
        شرکت مربوطه هیچکدام پاسخگو نبودند که در نهایت با طرح شکایت از طریق فرابازار در عرض سه روز کاری، کاال تحویل گردید. بدین
        وسیله از فرابازار تشکر و قدردانی به عمل می آورم. فرابازار محلی مطمئن برای شکایت از تولید کنندگان، انواع برندها و ارائه دهندگان
        خدمات که شما را تا حصول نتیجه همراهی می کند. فرابازار حامی حقوق مصرف کنندگان`
    }
]